import Head from 'next/head'

export default function BreadcrumbShowJsonLd ({ show }) {
  const station = (show.stations && show.stations.length > 0) ? show.stations[0] : null
  if (!station) return ''

  const series = (show.series && show.series.name) ? show.series : null

  const listItems = [
    {
      id: `${process.env.NEXT_PUBLIC_JSON_LD_ORGANISARTION_URL}/sender`,
      name: 'Sender'
    },
    {
      id: `${process.env.NEXT_PUBLIC_JSON_LD_ORGANISARTION_URL}/sender/${station.slug}`,
      name: `Videos der ${station.name} Mediathek`
    }
  ]
  if (series) {
    listItems.push(
      {
        id: `${process.env.NEXT_PUBLIC_JSON_LD_ORGANISARTION_URL}/sendungen/${series.slug}`,
        name: series.name
      }
    )
  }

  const jsonld = `{
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      ${listItems.map((item, index) => `
        {
          "@type": "ListItem",
          "position": ${index + 1},
          "item": {
            "@id": "${item.id}",
            "name": ${JSON.stringify(item.name)}
          }
        }`)}
    ]
  }`

  return (
    <Head>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: jsonld }}
        key='jsonld-breadcrumb-show'
      />
    </Head>
  )
}
